import { render, staticRenderFns } from "./RegulatedProfessionsModal.vue?vue&type=template&id=62e64c74&scoped=true"
import script from "./RegulatedProfessionsModal.vue?vue&type=script&lang=ts"
export * from "./RegulatedProfessionsModal.vue?vue&type=script&lang=ts"
import style0 from "./RegulatedProfessionsModal.vue?vue&type=style&index=0&id=62e64c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e64c74",
  null
  
)

export default component.exports